import { handleJSON } from '@/utils/fetch-utils';
import { headers } from './index';

const { API_URL } = process.env;

export default {
  endpoint: () => `${API_URL}/feature-flags/`,

  fetchFeatureFlags() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    return fetch(this.endpoint(), options).then(handleJSON);
  },
};
